import React, { useState } from 'react';
import moment from 'moment';

import { Modal } from '@material-ui/core';

const timeFormat = 'DD MMM YYYY hh:mm:ss a';

export default function SubmittedSolutionModal({ params }) {
  const [openSubmittedSolutionModal, setOpenSubmittedSolutionModal] =
    useState(false);

  const handleClose = () => {
    setOpenSubmittedSolutionModal(false);
  };

  return (
    <div>
      <div
        className='flex items-center h-full text-blue-600 cursor-pointer'
        onClick={() => {
          setOpenSubmittedSolutionModal(true);
        }}
      >
        {params?.data?.project?.attributes?.name || 'View submission'}
      </div>

      <Modal
        open={openSubmittedSolutionModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        className=''
      >
        <div className='relative top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={handleClose}
          >
            X
          </div>
          <h3 className='font-medium'>Submitted Solutions</h3>

          <hr className='mt-4 mb-4' />

          <div className='p-4 border-2 rounded-md'>
            <div className='flex'>
              <span className='text-sm font-normal opacity-60'>
                Codelab link:
              </span>
              <a
                href={params?.data?.solution?.codeLink}
                target='_blank'
                rel='noreferrer'
                className='flex items-center gap-2 ml-5 text-sm font-normal w-10/12 break-all'
              >
                {params?.data?.solution?.codeLink}
              </a>
            </div>

            <div className='flex mt-4'>
              <span className='text-sm font-normal opacity-60'>
                Video link:
              </span>
              <a
                href={params?.data?.solution?.videoLink}
                target='_blank'
                rel='noreferrer'
                className='flex items-center gap-2 ml-5 text-sm font-normal w-10/12 break-all'
              >
                {params?.data?.solution?.videoLink}
              </a>
            </div>

            {params?.data?.solution?.changes && (
              <div className='flex mt-4'>
                <span className='text-sm font-normal opacity-60'>
                  Revaluate reason:
                </span>
                <a
                  rel='noreferrer'
                  className='flex items-center gap-2 ml-5 text-sm font-normal'
                >
                  {params?.data?.solution?.changes}
                </a>
              </div>
            )}

            <div className='flex justify-end'>
              <span className='text-sm font-normal opacity-60'>
                Submitted on:{' '}
                {moment(params?.data?.submittedAt).format(timeFormat)}
              </span>
            </div>
          </div>

          {params?.data?.previousSolutions?.map((solutionObj, index) => {
            return (
              <div className='p-4 border-2 rounded-md mt-2' key={index}>
                <div className='flex'>
                  <span className='text-sm font-normal opacity-60'>
                    Codelab link:
                  </span>
                  <a
                    href={solutionObj?.solution?.codeLink}
                    target='_blank'
                    rel='noreferrer'
                    className='flex items-center gap-2 ml-5 text-sm font-normal'
                  >
                    {solutionObj?.solution?.codeLink}
                  </a>
                </div>

                <div className='flex mt-4'>
                  <span className='text-sm font-normal opacity-60'>
                    Video link:
                  </span>
                  <a
                    href={solutionObj?.solution?.videoLink}
                    target='_blank'
                    rel='noreferrer'
                    className='flex items-center gap-2 ml-5 text-sm font-normal'
                  >
                    {solutionObj?.solution?.videoLink}
                  </a>
                </div>

                <div className='flex justify-end'>
                  <span className='text-sm font-normal opacity-60'>
                    Submitted on:{' '}
                    {moment(solutionObj?.submittedAt).format(timeFormat)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
}
